import React from 'react';
import styles from './Widget.module.scss';

const Widget = ({ title, value, icon, tooltip, onClick, isActive, color }) => {
    const iconStyle = {
        backgroundColor: `var(--${color}-light)`,
        color: `var(--${color})`,
    };
    return (
        <div className={`${styles.widget} ${isActive ? styles.active : ''}`} onClick={onClick}>
            <div className={styles.iconWrapper} style={iconStyle}>
                <i className="material-icons">{icon}</i>
            </div>
            <div className={styles.content}>
                <span className={styles.title}>{title}</span>
                <span className={styles.value}>{value}</span>
            </div>
            <div className={styles.infoIconWrapper} data-tooltip={tooltip}>
                <i className="material-icons">info_outline</i>
            </div>
        </div>
    );
};

export default Widget;